import { Button, Col, Form, Input, Modal, Row } from "@shared/ui";
import React, { useEffect } from "react";

interface CampaignData {
  brandName: string;
  briefName: string;
  deliverables: string;
  timeline: string;
}

interface OnboardingEmailInfluencerProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: (values: CampaignData) => void;
}

const OnboardingEmailInfluencer: React.FC<OnboardingEmailInfluencerProps> = ({
  visible,
  onClose,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit({
        brandName: String(values.brandName ?? "").trim(),
        briefName: String(values.briefName ?? "").trim(),
        deliverables: String(values.deliverables ?? "").trim(),
        timeline: String(values.timeline ?? "").trim(),
      });
    } catch {
      /* validation errors surfaced by Form */
    }
  };

  return (
    <Modal
      title="Campaign Details"
      open={visible}
      onOk={handleOk}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Submit
        </Button>,
      ]}
      width={640}
    >
      <Form form={form} layout="vertical" requiredMark="optional">
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Brand name"
              name="brandName"
              rules={[{ required: true, message: "Enter brand name" }]}
            >
              <Input placeholder="Brand name" allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Brief name"
              name="briefName"
              rules={[{ required: true, message: "Enter brief name" }]}
            >
              <Input placeholder="Brief name" allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Deliverables"
              name="deliverables"
              rules={[{ required: true, message: "Enter deliverables" }]}
            >
              <Input placeholder="Describe deliverables" allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Timeline"
              name="timeline"
              rules={[{ required: true, message: "Enter timeline" }]}
            >
              <Input placeholder="e.g. 2 weeks, Jan–Mar" allowClear />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default OnboardingEmailInfluencer;
